import React, { createContext, useContext, useState, useEffect } from "react";
import en from "@/i18n/en";
import hi from "@/i18n/hi";

const DICTS = { en, hi };
const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("g360_lang") || "en");
  useEffect(() => {
    localStorage.setItem("g360_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (key) => DICTS[lang]?.[key] ?? DICTS.en[key] ?? key;
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
